import {dispatchStatus, type DispatchEntity} from "@ots-frontend/ots-data";
import {getDataGridStatusRowTheme} from "../DataGrid/dataGridTheme";

/** Shared by the canvas rows and block cards, retaining their established light colors. */
export function getDispatchDataGridRowTheme(
  record: DispatchEntity | undefined,
  scheme: "light" | "dark",
  hovered = false
) {
  const tone =
    record?.status?.code === dispatchStatus.canceled.code
      ? "danger"
      : !record?.personId
      ? "unassigned"
      : record?.status?.code === dispatchStatus.completed.code
      ? "success"
      : record?.status?.code === dispatchStatus.started.code
      ? "warning"
      : "neutral";
  return getDataGridStatusRowTheme(tone, scheme, hovered);
}
